import styled, { keyframes, css } from "styled-components";
import { colors } from "globalStyles";
import { media } from "utils/style-utils";
import { Link } from "react-router-dom";

export const PageWrapper = styled.div`
  padding-top: 132px;
  ${media.mobile_and_tablet`
    padding-top: 80px;
  `}
  ${media.mobile`
    padding-top: 80px;
  `}
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Stroke = keyframes`
  100% {
    stroke-dashoffset: 0;
  }
`;

export const Check = styled.path`
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  stroke: ${colors.LIGHT_GREEN};
  animation: ${Stroke} 0.75s cubic-bezier(0.65, 0, 0.45, 1) forwards;
  will-change: animation;
`;

export const CheckWrapper = styled.div`
  margin: 0 auto;
  // border: solid 1px magenta;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TextContainer = styled.div`
  opacity: 0;
  animation: ${keyframes`
  0% { opacity: 0; } 50% { opacity 0;}
  100% { opacity: 1; }
`} 1s ease-in;
  will-change: opacity;
  text-align: center;
  animation-fill-mode: forwards;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const H1 = styled.h1`
  margin-top: 0;
`;

export const Text = styled.p`
  margin: 0 auto;
  text-align: center;
  font-size: 16px;
  ${({ extraStyle }) => extraStyle && extraStyle}
`;

export const StyledLink = styled.span`
  color: ${colors.MAIN_COLOR};
`;

export const A = styled.a`
  color: ${colors.MAIN_COLOR};
  cursor: pointer;

  &:visited {
    color: ${colors.MAIN_COLOR};
  }
`;



// WEBPACK FOOTER //
// ./src/containers/ConfirmEmailPage/styledComponents.js